import { useMutation, useMutationState } from "@tanstack/react-query";
import { Button, notification } from "antd";
import { useMinhasRotas } from "pages/usuarioRota/hooks/useMinhasRotas";
import { apiSyncData } from "./api/apiSyncData";
import { SelectEmpresas } from "./SelectEmpresas";
import { UserMenu } from "./UserMenu/UserMenu";

export function TopBar() {
	const isAdmin = !!useMinhasRotas().data?.isAdmin;

	const mutationPostLoading = useMutationState({
		filters: { mutationKey: ["apiSyncData"] },
	});

	const mutationPost = useMutation({
		mutationKey: ["apiSyncData"],
		mutationFn: apiSyncData,
	});

	const loading = mutationPostLoading[mutationPostLoading.length - 1]?.status === "pending";

	const syncData = async (): Promise<void> => {
		try {
			await mutationPost.mutateAsync();

			notification.success({
				title: "Feito",
				description: "Sincronização finalizada com sucesso!!",
			});
		} catch {
			notification.error({
				title: "Error",
				description: "Houve um erro inesperado!!",
			});
		}
	};

	return (
		<div className="flex min-h-[4.5rem] items-center gap-4 px-4 md:px-8">
			<div className="min-w-0 flex-1">
				<SelectEmpresas />
			</div>

			<div className="flex shrink-0 items-center gap-3">
				{/* <h1 className="m-0 hidden whitespace-nowrap text-xl font-semibold leading-none text-[#3f48cd] sm:block xl:text-[28px]">
					Módulo Lacto
				</h1> */}
				{isAdmin && (
					<Button onClick={syncData} htmlType="button" loading={loading}>
						Sincronizar
					</Button>
				)}
			</div>

			<div className="flex shrink-0 items-center">
				<UserMenu />
			</div>
		</div>
	);
}
